import { useState } from 'react';
import { COLOR_PRESETS } from '../../constants/defaults';
import './ColorPicker.css';

export default function ColorPicker({
  label,
  value = '#818cf8',
  onChange,
  className = ''
}) {
  const [showCustom, setShowCustom] = useState(false);

  const handlePresetClick = (color) => {
    onChange?.(color);
    setShowCustom(false);
  };

  const handleCustomChange = (e) => {
    onChange?.(e.target.value);
  };

  const isPreset = COLOR_PRESETS.some(p => p.value.toLowerCase() === value.toLowerCase());

  return (
    <div className={`color-picker ${className}`}>
      {label && <label className="color-picker__label">{label}</label>}
      
      <div className="color-picker__presets">
        {COLOR_PRESETS.map((preset) => (
          <button
            key={preset.value}
            type="button"
            className={`color-picker__swatch ${value.toLowerCase() === preset.value.toLowerCase() ? 'color-picker__swatch--active' : ''}`}
            style={{ '--swatch-color': preset.value }}
            onClick={() => handlePresetClick(preset.value)}
            title={preset.name}
            aria-label={`Select ${preset.name}`}
          >
            {value.toLowerCase() === preset.value.toLowerCase() && (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </button>
        ))}
        <button
          type="button"
          className={`color-picker__custom-toggle ${showCustom || !isPreset ? 'color-picker__custom-toggle--active' : ''}`}
          onClick={() => setShowCustom(!showCustom)}
          title="Custom color"
          aria-label="Choose custom color"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a10 10 0 0 1 10 10" stroke="var(--accent)" />
            <path d="M12 2a10 10 0 0 0-10 10" stroke="#f472b6" />
            <path d="M12 22a10 10 0 0 1-10-10" stroke="#fbbf24" />
            <path d="M12 22a10 10 0 0 0 10-10" stroke="#34d399" />
          </svg>
        </button>
      </div>

      {(showCustom || !isPreset) && (
        <div className="color-picker__custom">
          <input
            type="color"
            value={value}
            onChange={handleCustomChange}
            className="color-picker__native"
          />
          <input
            type="text"
            value={value}
            onChange={(e) => {
              const val = e.target.value;
              if (/^#[0-9A-Fa-f]{0,6}$/.test(val)) {
                onChange?.(val);
              }
            }}
            className="color-picker__hex"
            placeholder="#000000"
            maxLength={7}
          />
          <div 
            className="color-picker__preview"
            style={{ backgroundColor: value }}
          />
        </div>
      )}
    </div>
  );
}
